export default "__VITE_ASSET__KbOYCtgK__"